import Text from 'src/components/ui/Text'
import { cx } from 'src/utils/cx'
import { BoostedMembershipIcon } from './BoostedMembershipIcon'

export interface CreditBoostChipProps {
  /**
   * Combined boost percentage across all applicable boosts. Treatment shows
   * a single bonus indicator rather than one chip per boost source.
   */
  percentage: number
  /**
   * Use the boosted gradient text style with a membership icon prefix.
   * Set when the boost set includes a Membership boost.
   */
  isBoostedGradient?: boolean
}

export function CreditBoostChip({
  percentage,
  isBoostedGradient,
}: CreditBoostChipProps) {
  if (percentage <= 0) return null

  return (
    <div className="flex items-center justify-center gap-1 text-sm md:text-base font-semibold leading-none">
      {isBoostedGradient && (
        <BoostedMembershipIcon className="size-4 shrink-0" />
      )}
      <span
        className={cx(
          isBoostedGradient
            ? 'bg-gradient-to-r from-[--boosted-gradient-from] to-[--boosted-gradient-to] bg-clip-text text-transparent'
            : 'text-[--bonus-green]',
        )}
      >
        <Text
          i18nKey="membership:extra-pack.card.plus-percent-bonus"
          values={{ percentage }}
          defaults="+{{percentage}}% Bonus"
        />
      </span>
    </div>
  )
}
